const LANGUAGE_REGEX = /[a-z]{2}-[A-Z]{2}/;

export function getLanguageResources() {
  const localesModules: Record<string, { default: Record<string, unknown> }> =
    import.meta.glob("@/assets/locales/*.json", {
      eager: true,
    });
  return Object.entries(localesModules).reduce((accu, [path, translation]) => {
    const language = LANGUAGE_REGEX.exec(path)?.[0];
    return {
      ...accu,
      ...(language && {
        [language]: {
          translation: translation.default,
        },
      }),
    };
  }, {});
}
